const url = "https://aftershoot.com";

const siteLinks = {
  Cull: `${url}/culling`,
  Edit: `${url}/edit`,
  Pricing: `/pricing`,
  Blog: `${url}/blog`,

  download: `${url}/downloads`,
  about: `${url}/about`,
  careers: `${url}/career`,
  press: `${url}/press`,
  faq: `${url}/culling-faq`,
  terms: `${url}/terms-of-use`,
  privacy: `${url}/privacy-policy`,
  community: "https://www.facebook.com/groups/aftershootusers",
};

export default siteLinks;
